import { Component } from 'react';
import { Button as BootstrapButton } from 'reactstrap';
import './button.css';

class Button extends Component {
  render() {
    let { iconClass } = this.props;

    let useIcon = false;
    if (iconClass) {
      iconClass = 'fa ' + iconClass;
      useIcon = true;
    }

    return (
      <BootstrapButton
        {...this.props}
        outline={this.props.outline}
        active={this.props.active}
        block={this.props.block}
        color={this.props.color}
        disabled={this.props.disabled}
        onClick={() => {
          this.props.onClick && this.props.onClick();
        }}
      >
        {this.props.text} {useIcon && <i className={iconClass}></i>}
      </BootstrapButton>
    );
  }
}

export default Button;
